import React from 'react'

function Culture() {
    return (
        <div>Culture</div>
    )
}

export default Culture